import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MessageSquare, X } from "lucide-react";

const FOUNDER_IMG = "/brand/founder-charles.png";

export function FounderChip({ compact = false }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="founder-chip"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 hover:border-emerald-500/40 text-slate-200 hover:text-white transition font-mono text-[11px] uppercase tracking-[0.2em] ${compact ? "h-8 px-3" : "h-9 px-4"}`}
        title="Message from the founder"
      >
        <MessageSquare className="w-3.5 h-3.5 text-emerald-300" />
        Welcome
      </button>
      <FounderModal open={open} onOpenChange={setOpen} />
    </>
  );
}

export function FounderModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="founder-modal"
        className="bg-[#0F111A] border-white/10 text-slate-100 max-w-3xl overflow-hidden p-0"
      >
        <div className="grid md:grid-cols-5">
          <div className="md:col-span-2 relative bg-black">
            <img
              src={FOUNDER_IMG}
              alt="Charles Cawv Thao — founder & president"
              className="w-full h-full object-cover object-center min-h-[280px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F111A] via-transparent to-transparent md:bg-gradient-to-r md:from-transparent md:to-[#0F111A]/40 pointer-events-none" />
          </div>
          <div className="md:col-span-3 p-6 md:p-8">
            <DialogHeader>
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-emerald-300">A note from the founder</div>
              <DialogTitle className="font-display text-2xl md:text-3xl font-extrabold text-white mt-2">
                Welcome to TradingoX
              </DialogTitle>
            </DialogHeader>
            <div className="mt-4 space-y-3 text-sm text-slate-300 leading-relaxed">
              <p>
                I built TradingoX to give everyday traders a tireless co-pilot — one that hunts micro-dips, banks
                small wins, and never lets emotion touch the trigger. Our belief is simple: many tiny profits, taken
                without ego, beat the swing-for-the-fences approach almost every time.
              </p>
              <p>
                You keep control of the risk knobs and your broker keeps custody of every dollar. TradingoX only ever
                gets a slice — 1.25% — of the profit it helps you make. If we don't earn you money, we don't earn a dime.
              </p>
              <p className="text-slate-400">
                Thank you for trusting us with your terminal. Trade well, trade small, trade often.
              </p>
            </div>
            <div className="mt-6 pt-5 border-t border-white/10">
              <img
                src="/brand/founder-signature.png"
                alt="Charles Cawv Thao signature"
                data-testid="founder-signature"
                className="h-14 md:h-16 w-auto -ml-2 mb-1 select-none pointer-events-none"
                style={{ filter: "brightness(0) invert(1)", opacity: 0.9 }}
                draggable={false}
              />
              <div className="font-display text-base font-bold text-white">Charles Cawv Thao</div>
              <div className="text-xs text-slate-400 mt-0.5">
                Founder & Lead Developer · President, <span className="text-slate-200 font-medium">XYSCOTECH</span> —
                <span className="text-slate-200"> IXYSCO LLC</span>
              </div>
            </div>
            <button
              onClick={() => onOpenChange(false)}
              className="absolute top-3 right-3 md:relative md:top-auto md:right-auto md:mt-6 md:ml-auto md:flex md:items-center md:justify-end md:w-full text-slate-400 hover:text-white"
            >
              <span className="md:inline-flex items-center gap-1 text-xs font-mono uppercase tracking-[0.2em]">
                <X className="w-3.5 h-3.5" /> close
              </span>
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default FounderChip;
